import { Button, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import UnitMeasures from "../UnitMeasures";
import Select from "react-select";

export default function AnalisysTypeForm({ state, parameters, handleInputChange, handleParamsChange, submit, isAddingOrEditing, isRegistering, handleDeleteAnalisysTypes }) {
    const { t } = useTranslation();
    const [params, setParams] = useState(state.params || [])
    const [selectedParameter, setSelectedParameter] = useState(null)

    useEffect(() => {
        handleParamsChange(params)
    }, [params])

    const addParameter = () => {
        if (selectedParameter) {
            const paramData = parameters.find(param => param._id === selectedParameter.value)
            const updatedParams = [...params, {
                parameter: paramData._id,
                unitMeasure: paramData.unitMeasure || "",
                minValue: paramData.minValue || 0,
                maxValue: paramData.maxValue || 0
            }]
            setParams(updatedParams)
            setSelectedParameter(null)
        }
    }

    const removeParameter = (index) => {
        const updatedParams = params.filter((_, i) => i !== index)
        setParams(updatedParams)
    }

    const updateParameter = (index, key, value) => {
        const updatedParams = params.map((param, i) =>
            i === index ? { ...param, [key]: key.includes("Value") ? Number(value) : value } : param
        )
        setParams(updatedParams)
    }

    return (
        <Form onSubmit={submit} className="px-4 formulario">
            <Row>
                <Col className="my-2">
                    <Form.Label>{t('admin.analisysTypes.name')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='name'
                        value={state.name || ''}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
            </Row>
            <Row>
                <Col className="my-2">
                    <h5>{t('admin.analisysTypes.parameters')}</h5>
                    <Row>
                        <Col>
                            <Select
                                className="select"
                                classNamePrefix="sd-select"
                                options={parameters.map(param => ({ value: param._id, label: param.name }))}
                                onChange={setSelectedParameter}
                                value={selectedParameter}
                                placeholder={t('admin.analisysTypes.selectParameter')}
                            />
                        </Col>
                        <Col>
                            <Button variant="fourth" onClick={addParameter}>{t('admin.analisysTypes.addParameter')}</Button>
                        </Col>
                    </Row>
                    <div className="my-3">
                        {params.map((param, index) => (
                            <Row key={index} className="mb-2">
                                <Col xs={12} md={11}>
                                    <Row>
                                        <Col xs={6} md={4}>
                                            <Form.Control
                                                className="sd-input"
                                                type='text'
                                                placeholder={t('admin.parameters.name')}
                                                value={parameters.find(p => p._id === param.parameter)?.name || param.parameter.name}
                                                disabled
                                            />
                                        </Col>
                                        <Col xs={6} md={2}>
                                            <Form.Control
                                                className="sd-input"
                                                type='number'
                                                step="any"
                                                placeholder={t('admin.parameters.minValue')}
                                                value={param.minValue}
                                                onChange={(e) => updateParameter(index, 'minValue', e.target.value)}
                                                onWheel={(e) => e.target.blur()}
                                            />
                                        </Col>
                                        <Col xs={6} md={2}>
                                            <Form.Control
                                                className="sd-input"
                                                type='number'
                                                step="any"
                                                placeholder={t('admin.parameters.maxValue')}
                                                value={param.maxValue}
                                                onChange={(e) => updateParameter(index, 'maxValue', e.target.value)}
                                                onWheel={(e) => e.target.blur()}
                                            />
                                        </Col>
                                        <Col xs={6} md={4}>
                                            <UnitMeasures
                                                onChange={(selected) => updateParameter(index, 'unitMeasure', selected?.value)}
                                                value={param.unitMeasure
                                                ? {
                                                    value: param.unitMeasure,
                                                    label: t(`measures.${param.unitMeasure}`)
                                                    }
                                                : null}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} md={1}>
                                    <Button variant="third" onClick={() => removeParameter(index)}>
                                        <i className="fas fa-trash"></i>
                                    </Button>
                                </Col>
                            </Row>
                        ))}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} lg={6} className="my-2 ms-auto">
                    <Button variant='primary' type="submit" className="w-100 my-2">
                        {isRegistering ? (
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        ) : isAddingOrEditing === 'editing' ? (
                            <>{t('global.edit')}</>
                        ) : (
                            <>{t('global.register')}</>
                        )}
                    </Button>
                    {isAddingOrEditing === 'editing' && (
                        <Button variant="fourth" className="w-100 my-2 cursor" onClick={(e) => handleDeleteAnalisysTypes(e, state?._id)}>
                            {t('global.delete')}
                        </Button>
                    )}
                </Col>
            </Row>
        </Form>
    );
}
